import { all } from 'redux-saga/effects'

import mainSaga from './main'
import searchSaga from './search'

export default function* gaioSaga() {
  yield all([
    mainSaga(),
    searchSaga()
  ])
}
